import { Outlet } from 'react-router-dom';
import MainLayout from './MainLayout';
import PgkbLogo from '../components/PgkbLogo';
import { useUser } from '@shared/hooks/useUser';

export default function MainLayoutWrapper() {
  const { user, loading } = useUser();

  if (loading || !user) {
    return (
      <div className="min-h-screen bg-surface-light dark:bg-surface-dark flex flex-col items-center justify-center gap-4">
        <PgkbLogo size="lg" />
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600"></div>
      </div>
    );
  }

  return (
    <MainLayout user={user}>
      <Outlet />
    </MainLayout>
  );
}
